const organisations = {
  remove_organisation: 'Disconnect this organisation.',
  share_contact_info: 'Share your contact information with that organisation',
  add_organisation: 'Connect to an organisation',
  delete_organisation_confirm: 'Are you sure you want to disconnect that organisation?',
  click_to_add: 'Click on an organisation to add it to the list of organisations you are connected to.',
};

export default organisations;
